import * as types from '../constants/action-types';

const initialState = {
  data: {},
  error: null,
  isPosting: false,
  isFetching: false
};

export default function contractReducer (state = initialState, action) {
  const { data, error, isPosting, isFetching } = action;

  switch (action.type) {
  case types.OFFER_QUOTE_CREATE_REQUEST:
  case types.OFFER_CREATE_REQUEST:
  case types.OFFER_WITHDRAW_REQUEST:
  case types.OFFER_ACCEPT_REQUEST:
  case types.OFFER_DECLINE_REQUEST:
  case types.HOST_UPDATE_DECLINE_REQUEST:
  case types.HOST_UPDATE_ACCEPT_REQUEST:
  case types.HOST_UPDATE_CREATE_REQUEST:
  case types.HOST_UPDATE_QUOTE_REQUEST:
  case types.GUEST_UPDATE_QUOTE_REQUEST:
    return {
      ...state,
      isPosting,
      error: null
    };

  case types.OFFER_QUOTE_CREATE_SUCCESS:
  case types.OFFER_CREATE_SUCCESS:
  case types.HOST_UPDATE_QUOTE_SUCCESS:
  case types.HOST_UPDATE_CREATE_SUCCESS:
  case types.GUEST_UPDATE_QUOTE_SUCCESS:
    return {
      ...state,
      quote: data,
      isPosting
    };

  case types.OFFER_WITHDRAW_SUCCESS:
  case types.OFFER_ACCEPT_SUCCESS:
  case types.OFFER_DECLINE_SUCCESS:
  case types.HOST_UPDATE_DECLINE_SUCCESS:
  case types.HOST_UPDATE_ACCEPT_SUCCESS:
    return {
      ...state
    };

  case types.OFFER_QUOTE_CREATE_FAILURE:
  case types.OFFER_CREATE_FAILURE:
  case types.OFFER_WITHDRAW_FAILURE:
  case types.OFFER_ACCEPT_FAILURE:
  case types.OFFER_DECLINE_FAILURE:
  case types.CONTRACTS_FETCH_FAILURE:
  case types.HOST_UPDATE_CREATE_FAILURE:
  case types.HOST_UPDATE_QUOTE_FAILURE:
  case types.HOST_UPDATE_DECLINE_FAILURE:
  case types.HOST_UPDATE_ACCEPT_FAILURE:
  case types.CONTRACTS_SNAPSHOT_FETCH_FAILURE:
  case types.GUEST_UPDATE_QUOTE_FAILURE:
    return {
      ...state,
      isPosting,
      isFetching,
      error
    };

  case types.CONTRACTS_FETCH_REQUEST:
  case types.CONTRACTS_SNAPSHOT_FETCH_REQUEST:
    return {
      ...state,
      isFetching
    };

  case types.CONTRACTS_FETCH_SUCCESS:
    return {
      ...state,
      contracts: data.contracts
    };

  case types.CONTRACTS_SNAPSHOT_FETCH_SUCCESS:
    return {
      ...state,
      data
    };

  case types.RESET_CONTRACT_STORE:
    return initialState;

  default:
    return state;
  }
}
